module.exports = __webpack_public_path__ + "static/agent-99-cleaning-sanitizer-solution-ebd92bbb65d4374f17f6bd248546e641.png";